<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="title">
<p class="bk">Strangers</p>
<p class="bk1">A Faye Longchamp Mystery</p>
<p class="bkau">Mary Anna Evans</p>
<p class="bkau1"><a class="calibre1" href="http://www.maryannaevans.com" target="_blank">www.maryannaevans.com</a></p>
<p class="bkpub">Poisoned Pen Press</p>
<p class="body-center"><span class="calibre2"><img alt="ppp-logo.png" class="frame" src="OEBPS/Images/ppp-logo.png"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-strangers002.vue?b2bd3c6a